
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ProductDetail",
      function () {
        return require("private-next-pages/ProductDetail.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ProductDetail"])
      });
    }
  